var _rect, _text, _text2, _line, _line2, _line3, _line4, _line5, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _line6, _text19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase1Fig4JudgeSuiteGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 630",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 630,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The judge suite as a receipt of compounding")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Machine checks in the judge suite across roughly three weeks, ending at 2,033.")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 505,
    x2: 1140,
    y2: 505,
    stroke: "#D4DDD6",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 412.8,
    x2: 1140,
    y2: 412.8,
    stroke: "#D4DDD6",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 320.5,
    x2: 1140,
    y2: 320.5,
    stroke: "#D4DDD6",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 228.3,
    x2: 1140,
    y2: 228.3,
    stroke: "#D4DDD6",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 136.1,
    x2: 1140,
    y2: 136.1,
    stroke: "#D4DDD6",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 509,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 11,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "0")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 416.8,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 11,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "500")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 324.5,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 11,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "1000")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 232.3,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 11,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "1500")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 140.1,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 11,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "2000")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 273,
    y: 530,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "WEEK 1")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 530,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "WEEK 2")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 967,
    y: 530,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "WEEK 3")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 502.6 L330 502.6 L330 497.8 L520 497.8 L520 470.3 L710 470.3 L710 387.4 L900 387.4 L900 212.6 L1090 212.6 L1090 130 L1140 130",
    fill: "none",
    stroke: "#16A34A",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 502.6,
    r: 4.5,
    fill: "#16A34A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 497.8,
    r: 4.5,
    fill: "#16A34A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 470.3,
    r: 4.5,
    fill: "#16A34A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 710,
    cy: 387.4,
    r: 4.5,
    fill: "#16A34A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 212.6,
    r: 4.5,
    fill: "#16A34A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1090,
    cy: 130,
    r: 4.5,
    fill: "#16A34A"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 484,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 14,
    fontWeight: 700,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "13")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 479,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 14,
    fontWeight: 700,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "39")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 452,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 14,
    fontWeight: 700,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "188")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 369,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 14,
    fontWeight: 700,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "637")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 900,
    y: 194,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 14,
    fontWeight: 700,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "1,584")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 1090,
    y: 112,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#16A34A",
    textAnchor: "middle"
  }, "2,033")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 1044,
    y: 146,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "end"
  }, "plus 44 external checks")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 1044,
    y: 164,
    fontSize: 12.5,
    fill: "#4A5F56",
    textAnchor: "end"
  }, "run beside these")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1052,
    y1: 150,
    x2: 1080,
    y2: 134,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 598,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "From 13 to 2,033 machine checks in roughly three weeks, each hardening left its checks behind, and 44 external checks run beside them.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase1Fig4JudgeSuiteGrowth);
export default __webpack_public_path__ + "static/media/case1-fig4-judge-suite-growth.89bbfb268737d02290f85c705c7834ed.svg";
export { ForwardRef as ReactComponent };